import { RouterProvider } from 'react-router-dom';

// project import
import router from "./router/index";
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
// import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
// import Snackbar from 'components/@extended/Snackbar';

import { WebSocketProvider } from "contexts/WebSocketContext";
import { AuthProvider } from 'contexts/AuthContext';
import { BreadStorageProvider } from 'contexts/BreadStorageContext';
import { UserSettingProvider } from 'contexts/UserContext';
import { getWebSocketURL } from "utils/serverUrl";

// auth-provider

const WEBSOCKET_URL = getWebSocketURL();
const CHECK_MOCKUP = process.env.REACT_APP_IS_MOCKUP;
const CHECK_CONTEXT = process.env.REACT_APP_RUNNING_CONTEXT;
console.log('WEBSOCKET_URL=' + WEBSOCKET_URL);
console.log('CHECK_MOCKUP=' + CHECK_MOCKUP);
console.log('CHECK_CONTEXT=' + CHECK_CONTEXT);
// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {

  return (
    <ThemeCustomization>
      <WebSocketProvider url={WEBSOCKET_URL}>
        <Locales>
          <ScrollTop>
            <AuthProvider>
              <UserSettingProvider>
                <BreadStorageProvider>
                  <RouterProvider router={router} />
                </BreadStorageProvider>
              </UserSettingProvider>
            </AuthProvider>
          </ScrollTop>
        </Locales>
      </WebSocketProvider>
    </ThemeCustomization>
  );
}
